import {Component, inject, OnInit} from '@angular/core';
import {
  ControlContainer,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormGroup,
} from '@angular/forms';
import {MatIconModule} from '@angular/material/icon';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {
  AVAILABLE_FILTERS_SOURCES,
  AvailablePriceChangeOperators,
} from '@em/data-feed/util-types';
import {EmSelectOperandModule} from '@em/shared/mapping-engine/feature';
import {EmInputModule, EmSelectModule, EmMoreInfoModule} from '@em/shared/ui';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'em-price-changes-filter',
  templateUrl: './price-changes-filter.component.html',
  styleUrls: ['./price-changes-filter.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    MatIconModule,
    EmSelectModule,
    EmInputModule,
    EmSelectOperandModule,
    MatSlideToggleModule,
    EmMoreInfoModule,
  ],
})
export class EmPriceChangesFilterComponent implements OnInit {
  private readonly _controlContainer = inject(ControlContainer);
  formGroup: UntypedFormGroup | null | undefined;

  pricesList = [
    {label: 'G_FILTER_MIN_PRICE_VALUE', value: 'min_price'},
    {label: 'G_FILTER_MIN_PRICE_FULL_VALUE', value: 'min_price_full'},
    {label: 'G_FILTER_AVG_PRICE_VALUE', value: 'avg_price'},
    {label: 'G_FILTER_MIN_PRICE_FULL_VALUE', value: 'avg_price_full'},
  ];
  operators = AvailablePriceChangeOperators;
  sources = AVAILABLE_FILTERS_SOURCES;

  ngOnInit(): void {
    this.formGroup = this._controlContainer.control as UntypedFormGroup;
  }
}
